module.exports = __webpack_public_path__ + "static/img/son3.f9c0896c.png";